/**
 * studentRealizationsViewModel — `(reduxState) → props` des « Activités faites » de l'élève
 * (patron A), la route `realizations` ouverte par « Voir plus ».
 *
 * La liste est celle du parent, lue telle quelle : l'élève ouvre l'écran sans `studentId`
 * (`TodoListScreen.js:828-840`), donc `RealizationsTabScreen.js:70-78` appelle
 * `getFinishedActivities` (« moi ») et lit `user.history.activities` — exactement ce que
 * `realizationsViewModel(state, null)` lit. L'élève n'y ajoute que la carte d'offre au-dessus de
 * sa liste (`BecomePremiumCard`, `RealizationsTabScreen.js:196-203`), déduite de son compte.
 */
import { createSelector } from "reselect"

import { studentOffer, type StudentOffer } from "../../../adapters/student/shared/studentOfferAdapter"
import { realizationsViewModel, type RealizationsViewModel } from "../../parent/Activities/realizationsViewModel"
import { selectDisplayedStudent } from "../../shared/displayedStudent"

export type StudentRealizationsViewModel = RealizationsViewModel & {
    /** La carte d'offre au-dessus de la liste. Absente : rien au-dessus. */
    offer: StudentOffer | null
}

/** Redux root is still untyped in this app — keep the VM boundary explicit. */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type ReduxState = any

export const studentRealizationsViewModel = createSelector(
    [
        (state: ReduxState) => realizationsViewModel(state, null),
        (state: ReduxState) => selectDisplayedStudent(state)?.roles,
        (state: ReduxState) => selectDisplayedStudent(state)?.subscription_state,
    ],
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    (list: RealizationsViewModel, roles: any, subscriptionState: any): StudentRealizationsViewModel => ({
        ...list,
        offer: studentOffer({ roles, subscription_state: subscriptionState }),
    })
)
